export type RegionalConnectorId = "fiskil" | "plaid";

export type RegionalSystemPlugin = {
  id: RegionalConnectorId;
  name: string;
  keywords: string[];
};

/** Regional bank connectors shown in the account-regions dialog (searchable). */
export const REGIONAL_SYSTEM_PLUGINS: RegionalSystemPlugin[] = [
  {
    id: "fiskil",
    name: "Connect Bank Accounts (Australia)",
    keywords: ["fiskil", "bank", "accounts", "australia", "au", "banking", "open banking"],
  },
  {
    id: "plaid",
    name: "Connect Bank Accounts (United States)",
    keywords: ["plaid", "bank", "accounts", "united states", "us", "usa", "banking"],
  },
];

export function matchesRegionalPluginSearch(
  query: string,
  id: RegionalConnectorId,
  plugins: RegionalSystemPlugin[] = REGIONAL_SYSTEM_PLUGINS,
): boolean {
  const normalizedQuery = query.toLowerCase().trim();
  if (!normalizedQuery) {
    return true;
  }

  const plugin = plugins.find((entry) => entry.id === id);
  if (!plugin) {
    return false;
  }

  return (
    plugin.name.toLowerCase().includes(normalizedQuery) ||
    plugin.keywords.some((keyword) => keyword.includes(normalizedQuery))
  );
}
